import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b72d139"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "punpay-textarea-wrap" }
const _hoisted_2 = { class: "textarea-title" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import {computed, ref} from "vue";
import {UiTextarea} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'runpay-textarea',
  props: {
  modelValue: {
    type: String,
    default: "",
  },
  validFunction: {
    type: Function,
    default: null,
  },
  label: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String || ref<any>,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  maxHeight: {
    type: String,
    default: "112px",
  },
  minHeight: {
    type: String,
    default: "112px",
  },

  /**
   * Параметры для валидации
   */
  params: {
    type: Object,
    default: null,
  },
},
  emits: ["update:modelValue", "focus", "blur", "validation"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "234f013a": (__props.minHeight),
  "7f652e16": (__props.maxHeight)
}))



/**
 * События
 */


/**
 * Внутреннее значение
 */
const innerValue = ref<string>("");
/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value: string) => {
    emit("update:modelValue", value);
    innerValue.value = value;
  },
});
const text = ref();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiTextarea), {
      ref_key: "text",
      ref: text,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      placeholder: __props.placeholder,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"]),
    (__props.errorMessage?.toString().length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})